import { createContext, useEffect, useContext, useState } from 'react';
import { api } from '../../../services/api';
import { toast } from 'react-toastify';
import { useMisc } from '../../../contexts/MiscContext';
import PAChecklistMain from './pa_checklist_main';
import { isNullish } from '../../../utils/misc_utils';
import CookiesService from '../../../services/cookies';
import imageCompression from 'browser-image-compression';
// import { v4 as uuidv4 } from 'uuid';
// import useSocketHandler from '../../../services/socket_io_handler';

const PAChecklistContext = createContext();
export const usePAChecklist = () => useContext(PAChecklistContext);

export const PAChecklistProvider = () => {
  const { setShowLoading } = useMisc();

  const [showLoadingCaixa, setShowLoadingCaixa] = useState(false);
  const [showLoadingAnalise, setShowLoadingAnalise] = useState(false);
  const [showLoadingProvaDeRoupa, setShowLoadingProvaDeRoupa] = useState(false);

  const [idOperacaoAtiva, setIdOperacaoAtiva] = useState(null);
  const [userId] = useState(CookiesService.getUserId());
  // const [isAdmin] = useState(CookiesService.isUserAdmin());
  // const [usuarioCaixa] = useState(CookiesService.getAcessos()['PA - Checklist - Caixa']);
  // const [usuarioAnalise] = useState(CookiesService.getAcessos()['PA- Checklist - Análise']);
  // const [usuarioProvaRoupa] = useState(CookiesService.getAcessos()['PA - Checklist - Prova de Roupa']);
  const [interfaceAtiva, setInterfaceAtiva] = useState(101); // Caixa - 101 | Análise - 102 | Prova de Roupa - 103;

  const [filterObjCaixa, setFilterObjCaixa] = useState({ romaneio_nf_saida: '' });
  const [filterObjAnalise, setFilterObjAnalise] = useState({ nf_entrada: '', produto: '', cor_produto: '', romaneio_nf_saida: '', revisao_ok: false });
  const [filterObjProvaDeRoupa, setFilterObjProvaDeRoupa] = useState({ nf_entrada: '', produto: '', cor_produto: '', romaneio_nf_saida: '', revisao_ok: false });
  const [modalCancelamento, setModalCancelamento] = useState(false);
  const [idsCancelamento, setIdsCancelamento] = useState([]);

  // --- Listagens --- //
  const [listaDefeitos, setListaDefeitos] = useState([]);
  const [listaDefeitosPiloto, setListaDefeitosPiloto] = useState([]);
  const [listaDestinoInternacional, setListaDestinoInternacional] = useState([]);
  const [listaDestinoNacional, setListaDestinoNacional] = useState([]);
  const [listaStatusAnalise, setListaStatusAnalise] = useState([]);
  const [listaStatusDefeito, setListaStatusDefeito] = useState([]);
  const [listaLocalizacaoDefeito, setListaLocalizacaoDefeito] = useState([]);
  const [listaMarca, setListaMarca] = useState([]);
  const [listaCanal, setListaCanal] = useState([]);
  const [listaDesenvolvimento, setListaDesenvolvimento] = useState([]);
  const [listaMotivoEnvio, setListaMotivoEnvio] = useState([]);
  const [listaAreaAprovacao, setListaAreaAprovacao] = useState([]);
  const [listaMedidas, setListaMedidas] = useState([]);
  const [listaPartesMedidas, setListaPartesMedidas] = useState([]);
  const [listaDefeitosComp, setListaDefeitosComp] = useState([]);
  const [listaDefeitosProvaRoupa, setListaDefeitosProvaRoupa] = useState([]);
  const [listaLocalizacoesProvaRoupa, setListaLocalizacoesProvaRoupa] = useState([]);
  const [listaRomaneioMedidas, setListaRomaneioMedidas] = useState([]);

  // --- Modal Informações --- //
  const [informacoesCarregadas, setInformacoesCarregadas] = useState({});
  const [showModalInformacoes, setShowModalInformacoes] = useState(false);
  const [informacaoAtiva, setInformacaoAtiva] = useState(false);
  const [carregandoDefeitosPit, setCarregandoDefeitosPit] = useState(false);
  const [carregandoChamados, setCarregandoChamados] = useState(false);
  const [ativarModalInformacao, setAtivarModalInformacao] = useState(false);

  // --- Etapa 1: Conferência de Caixa --- //
  const [modalCaixa, setModalCaixa] = useState(false);
  const [subModalCaixa, setSubModalCaixa] = useState(false);
  const [listaChecklistCaixa, setListaChecklistCaixa] = useState([]);
  const [listaChecklistCaixaFiltrada, setListaChecklistCaixaFiltrada] = useState([]);
  const [romaneioSelecionado, setRomaneioSelecionado] = useState({});
  const [limparItemsSelecionadosCaixa, setLimparItemsSelecionadosCaixa] = useState(true);
  const [itemEmAnaliseCaixa, setItemEmAnaliseCaixa] = useState({});
  const [listaProducoesRomaneioSelecionado, setListaProducoesRomaneioSelecionado] = useState([]);
  const [formularioCaixa, setFormularioCaixa] = useState([
    {
      possui_peca_piloto: null,
      preco_tag_divergente: { key: false, value: '' },
      composicao_tag_divergente: { key: false, value: null },
      id_entrada_fiscal: null
    }
  ]);

  // --- Etapa 2: Análise --- //
  // -- 2.a: Direcionamento -- //
  const [listaChecklistAnalise, setListaChecklistAnalise] = useState([]);
  const [listaChecklistAnaliseFiltrada, setListaChecklistAnaliseFiltrada] = useState([]);
  const [modalAnalise, setModalAnalise] = useState(false);
  const [modalDirecionamento, setModalDirecionamento] = useState(false);
  const [modalProcessamento, setModalProcessamento] = useState(false);
  const [gradeChecklist, setGradeChecklist] = useState([]);
  const [gradeRomaneio, setGradeRomaneio] = useState([]);
  const [revisaoResultado, setRevisaoResultado] = useState([]);
  const [revisaoDirecionamentos, setRevisaoDirecionamentos] = useState([]);
  const [referenciaSelecionada, setReferenciaSelecionada] = useState({});
  const [direcionamentoChecklist, setDirecionamentoChecklist] = useState([]);
  const [quantidadeTotalDirecionada, setQuantidadeTotalDirecionada] = useState(0);
  const [resultadoCaixa, setResultadoCaixa] = useState([]);
  const [possuiPecaPiloto, setPossuiPecaPiloto] = useState(false);
  const [precoTagDivergente, setPrecoTagDivergente] = useState({ key: false, value: '' });
  const [composicaoTagDivergente, setComposicaoTagDivergente] = useState({ key: false, defeitos: [] });
  const [combinacoesImagens, setCombinacoesImagens] = useState([]);
  const [imagensExtras, setImagensExtras] = useState([]);
  const [localizacaoPilotoAnalise, setLocalizacaoPilotoAnalise] = useState([]);
  const [formularioAnalise, setFormularioAnalise] = useState({
    ziper: null,
    gradacao: null,
    fio_detectado: null,
    dispensar_medidas: false
  });

  // -- 2.b: Medidas -- //
  const [formulariosMedida, setFormulariosMedida] = useState([]);
  const [modalMedidas, setModalMedidas] = useState(false);
  const [medidasAtelier, setMedidasAtelier] = useState([]);
  const [medidasInseridas, setMedidasInseridas] = useState([]);
  const [atelierDesenhoTecnico, setAtelierDesenhoTecnico] = useState('');
  const [qtdePecasComposicao, setQtdePecasComposicao] = useState(0);
  const [formulariosPecasComposicaoUm, setFormulariosPecasComposicaoUm] = useState([]);
  const [formulariosPecasComposicaoDois, setFormulariosPecasComposicaoDois] = useState([]);
  const [formulariosPecasComposicaoTres, setFormulariosPecasComposicaoTres] = useState([]);

  // --- Etapa 3: Prova de Roupa --- //
  const [modalProvaDeRoupa, setModalProvaDeRoupa] = useState(false);
  const [listaChecklistProvaDeRoupa, setListaChecklistProvaDeRoupa] = useState([]);
  const [listaChecklistProvaDeRoupaFiltrada, setListaChecklistProvaDeRoupaFiltrada] = useState([]);
  const [medidasAnalise, setMedidasAnalise] = useState([]);
  const [imagemDesenhoTecnico, setImagemDesenhoTecnico] = useState(null);

  // --- --- --- --- --- --- --- //

  useEffect(() => {
    (async () => {
      await fetchChecklistInicializacao();
      // await fetchChecklistGrid(999);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (interfaceAtiva === 101 && listaChecklistCaixaFiltrada.length === 0) await fetchChecklistGrid(101);
      if (interfaceAtiva === 102 && listaChecklistAnaliseFiltrada.length === 0) await fetchChecklistGrid(102);
      if (interfaceAtiva === 103 && listaChecklistProvaDeRoupaFiltrada.length === 0) await fetchChecklistGrid(103);
    })()
  }, [interfaceAtiva]);

  // const socketRef = useSocketHandler({
  //   tipoInterface: 'checklist',
  //   idOperacaoAtiva,
  //   setListaChecklistCaixa,
  //   setListaChecklistAnalise,
  //   setListaChecklistProvaDeRoupa,
  //   setShowLoadingCaixa,
  //   setShowLoadingAnalise,
  //   setShowLoadingProvaDeRoupa,
  // });

  // useEffect(() => {
  //   if (socketRef?.current) {
  //     (async () => {
  //       setShowLoadingCaixa(true);
  //       setShowLoadingAnalise(true);
  //       setShowLoadingProvaDeRoupa(true);
  //       await socketRef?.current.emit('checklist:refresh', 999);
  //     })();
  //   }
  // }, [socketRef]);

  const resetData = () => {
    setModalCancelamento(false);
    setIdOperacaoAtiva(null);

    // --- Caixa --- //
    setListaProducoesRomaneioSelecionado([]);
    setModalCaixa(false);
    setSubModalCaixa(false);
    setLimparItemsSelecionadosCaixa(false);
    setItemEmAnaliseCaixa({});
    setFormularioCaixa([
      {
        possui_peca_piloto: null,
        preco_tag_divergente: { key: false, value: '' },
        composicao_tag_divergente: { key: false, value: null },
        id_entrada_fiscal: null
      }
    ]);

    // --- Medidas --- //
    setModalMedidas(false);
    setMedidasAtelier([]);
    setMedidasInseridas([]);
    setAtelierDesenhoTecnico('');
    setQtdePecasComposicao(0);
    setFormulariosPecasComposicaoUm([]);
    setFormulariosPecasComposicaoDois([]);
    setFormulariosPecasComposicaoTres([]);

    // --- Análise --- //
    setLocalizacaoPilotoAnalise([]);
    setPossuiPecaPiloto(false);
    setListaChecklistAnalise([]);
    setListaChecklistAnaliseFiltrada([]);
    setModalAnalise(false);
    setModalDirecionamento(false);
    setModalProcessamento(false);
    setGradeChecklist([]);
    setRevisaoResultado([]);
    setRevisaoDirecionamentos([]);
    setMedidasAnalise([]);
    setImagemDesenhoTecnico(null);
    setReferenciaSelecionada({});
    setDirecionamentoChecklist([]);
    setQuantidadeTotalDirecionada(0);
    setResultadoCaixa([]);
    setFormularioAnalise({
      ziper: null,
      gradacao: null,
      fio_detectado: null,
      dispensar_medidas: false
    });
    setPrecoTagDivergente({ key: false, value: '' });
    setComposicaoTagDivergente({ key: false, defeitos: [] });
    setCombinacoesImagens([]);
    setImagensExtras([]);

    // --- Prova de Roupa -- //
    setModalProvaDeRoupa(false);
  }

  // --- Miscellaneous --- //

  // WEBSOCKETS
  // const cancelarChecklist = async () => {
  //   try {
  //     await new Promise((resolve, reject) => {
  //       socketRef?.current.emit(
  //         'checklist:force-disconnect',
  //         idsCancelamento,
  //         (res) => {
  //           if (res?.status === 'ok') resolve();
  //           else reject(new Error(res?.error || 'Falha ao cancelar operação.'));
  //         }
  //       );
  //     });

  //     resetData();
  //   } catch (err) {
  //     toast.error(err.message);
  //   }
  // }

  const cancelarChecklist = async () => {
    try {
      const idControleArr = [
        ...listaProducoesRomaneioSelecionado.map(item => item.id_controle),
        ...(referenciaSelecionada.id_controle ? [referenciaSelecionada.id_controle] : [])
      ];

      fetchChecklistGrid(999);
      await api.post('/pa-checklist/checklist-cancelar-analise', { idControleArr });
      resetData();
    } catch (e) {
      toast.error('Erro ao cancelar a operação.\nTente novamente ou entre em contato com o suporte.');
    }
  }

  const fetchChecklistInicializacao = async () => {
    try {
      setShowLoading(true);
      const res = await api.get('/pa-checklist/checklist-inicializacao');
      setListaDefeitos(res.data.resListaDefeitos);
      setListaDefeitosPiloto(res.data.resListaDefeitosPiloto);

      setListaDestinoInternacional(res.data.resListaDestinoInternacional);
      setListaDestinoNacional(res.data.resListaDestinoNacional);

      setListaStatusAnalise(res.data.resListaStatusAnalise);
      setListaStatusDefeito(res.data.resListaStatusDefeito);
      setListaLocalizacaoDefeito(res.data.resListaLocalizacaoDefeito);
      // setListaMedidas(res.data.resListaMedidas);
      setListaMarca(res.data.resListaMarca);
      setListaCanal(res.data.resListaCanal);
      setListaDesenvolvimento(res.data.resListaDesenvolvimento);
      setListaMotivoEnvio(res.data.resListaMotivoEnvio);
      setListaAreaAprovacao(res.data.resListaAreaAprovacao);
      setListaDefeitosComp(res.data.resListaDefeitosComp);
      setListaPartesMedidas(res.data.resListaPartesMedidas);
      setListaDefeitosProvaRoupa(res.data.resListaDefeitosProvaRoupa);
      setListaLocalizacoesProvaRoupa(res.data.resListaLocalizacoesProvaRoupa);
    } catch (e) {
      toast.error('Ocorreu um erro ao inicializar a interface.\nPor favor cheque sua conexão com a internet ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const fetchChecklistGrid = async (type) => {
    if (type === 101 || type === 1001 || type === 999) {
      try {
        setShowLoadingCaixa(true);
        const res = await api.get('pa-checklist/checklist-caixa-get-main-data');
        setListaChecklistCaixa(res.data);
      } catch (e) {
        toast.error('Ocorreu um erro ao carregar a listagem da conferência de caixa.\nTente novamente ou entre em contato ocm o suporte.');
      } finally {
        setShowLoadingCaixa(false);
      }
    }
    if (type === 102 || type === 1001 || type === 1002 || type === 999) {
      try {
        setShowLoadingAnalise(true);
        const res = await api.get('pa-checklist/checklist-analise-get-main-data');
        setListaChecklistAnalise(res.data);
      } catch (e) {
        toast.error('Ocorreu um erro ao carregar a listagem da análise.\nTente novamente ou entre em contato ocm o suporte.');
      } finally {
        setShowLoadingAnalise(false);
      }
    }
    if (type === 103 || type === 999) {
      try {
        setShowLoadingProvaDeRoupa(true);
        const res = await api.get('pa-checklist/checklist-prova-get-main-data');
        setListaChecklistProvaDeRoupa(res.data);
      } catch (e) {
        toast.error('Ocorreu um erro ao carregar a listagem da prova de roupa.\nTente novamente ou entre em contato ocm o suporte.');
      } finally {
        setShowLoadingProvaDeRoupa(false);
      }
    }
  }

  // --- Funções Conferência de Caixa --- //
  useEffect(() => {
    setLimparItemsSelecionadosCaixa(false);
  }, [limparItemsSelecionadosCaixa]);

  const fecharModalCaixa = async () => {
    setRomaneioSelecionado({});
    setLimparItemsSelecionadosCaixa(true);
    setModalCaixa(false);
    setFormularioCaixa([
      {
        possui_peca_piloto: null,
        preco_tag_divergente: { key: false, value: '' },
        composicao_tag_divergente: { key: false, value: null },
        id_entrada_fiscal: null
      }
    ]);
  }

  const iniciarChecklistCaixa = async (row) => {
    const params = {
      romaneio_nf_saida: row.romaneio_nf_saida,
      romaneio_entrada: row.romaneio_entrada
    }

    try {
      setShowLoading(true);

      const res = await api.get('/pa-checklist/checklist-iniciar-caixa', { params });
      setListaProducoesRomaneioSelecionado([...res.data]);
      setRomaneioSelecionado({ ...row });
      setModalCaixa(true);

      // WEBSOCKETS
      // const arrId = res.data.map((obj) => obj.id_controle);
      // const idOperacao = uuidv4();
      // setIdOperacaoAtiva(idOperacao);

      // socketRef?.current.emit('checklist:iniciar', { idOperacao, arrId, type: 101 }, (res) => {
      //   if (!res.status) toast.error('Erro ao iniciar operação.');
      // });

      // setShowLoadingCaixa(true);
    } catch (e) {
      const errorCode = e.response?.data?.errorCode;
      if (errorCode === 50001)
        return toast.warn('Não foi possível abrir a caixa. Outro usuário já está processando uma ou mais produções possíveis desta caixa.');
      if (errorCode === 50002)
        return toast.warn('Não foi possível encontrar a grade de uma ou mais das produções selecionadas.\nPor favor tente novamente ou entre em contato com um analista.');

      toast.error('Ocorreu um erro inesperado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const validarProcessamentoCaixa = (formularioFiltrado) => {
    for (const item of formularioFiltrado) {
      const { possui_peca_piloto, preco_tag_divergente, composicao_tag_divergente } = item;
      if (possui_peca_piloto === null) return false;
      if (preco_tag_divergente.key && isNullish(preco_tag_divergente.value)) return false;
      if (composicao_tag_divergente.key && isNullish(composicao_tag_divergente.value)) return false;
    }
    return true;
  }

  const processarChecklistCaixa = async (entradasSelecionadas) => {
    try {
      const formularioFiltrado = formularioCaixa
        .filter(fc => entradasSelecionadas.some(es => es.id_entrada_fiscal === fc.id_entrada_fiscal))
        .map(fc => ({
          ...entradasSelecionadas.find(es => es.id_entrada_fiscal === fc.id_entrada_fiscal),
          ...fc,
        }));
      if (!validarProcessamentoCaixa(formularioFiltrado)) return toast.warning('Por favor preencha os formulários corretamente.');
      setShowLoading(true);

      const produtosParaProcessar = formularioFiltrado.map(item => {
        const precoTagDivergente = item.preco_tag_divergente;
        const composicaoTagDivergente = item.composicao_tag_divergente;
        return {
          ...item,
          id_entrada_fiscal: item.id_entrada_fiscal,
          produto: item.produto,
          cor_produto: item.cor_produto,
          romaneio_entrada: romaneioSelecionado.romaneio_entrada.trim(),
          romaneio_nf_saida: romaneioSelecionado.romaneio_nf_saida.trim(),
          possui_peca_piloto: item.possui_peca_piloto,
          preco_tag_divergente: precoTagDivergente.key ? precoTagDivergente.value : null,
          composicao_tag_divergente: composicaoTagDivergente.key ? composicaoTagDivergente.value.value : null,
          id_usuario_responsavel: userId
        }
      });
      const idsParaProcessar = produtosParaProcessar.map(fc => fc.id_entrada_fiscal);
      const idsParaLiberar = formularioCaixa
        .filter(fc => fc.id_entrada_fiscal && !idsParaProcessar.includes(fc.id_entrada_fiscal))
        .map(fc => fc.id_entrada_fiscal);
      const params = { produtosParaProcessar, idsParaProcessar, idsParaLiberar }
      await api.post('/pa-checklist/checklist-processamento-caixa', params);

      // await socketRef?.current.emit('checklist:refresh', 1001);
      await fetchChecklistGrid(1001);

      toast.success('Processamento completado com sucesso!');
      resetData();
    } catch (e) {
      toast.error('Houve um problema durante o processamento.\nPor favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  // --- Funções Análise && Medidas --- //
  const iniciarChecklistAnalise = async (ref) => {
    try {
      setShowLoading(true);

      const params = {
        nf_entrada: ref.nf_entrada,
        serie_nf: ref.serie_nf,
        origem: ref.origem,
        ordem_producao: ref.ordem_producao,
        produto: ref.produto,
        cor_produto: ref.cor_produto,
        qtde_entrada: ref.qtde_entrada,
        filial_revisao: ref.filial_revisao,
        id_controle: ref.id_controle,
        id_entrada_fiscal: ref.id_entrada_fiscal,
        marca: ref.marca,
        romaneio_entrada: ref.romaneio_entrada,
        user_type: interfaceAtiva
      }

      const res = await api.get('/pa-checklist/checklist-iniciar-analise', { params });
      const { resGrade, resRevisaoResultado, resRevisaoDirecionamentos, resMedidasAtelier, resMedidas, resQtdeRomaneio, resMedidasInseridas, resCaixa, resAtelierDesenhoTecnico, resListaRomaneioMedidas, resLocalizacaoPiloto } = res.data;

      setListaRomaneioMedidas(resListaRomaneioMedidas);
      setGradeChecklist(resGrade);
      setRevisaoResultado(resRevisaoResultado);
      setRevisaoDirecionamentos(resRevisaoDirecionamentos);
      setMedidasAtelier(resMedidasAtelier);
      setListaMedidas(resMedidas);
      setMedidasInseridas(resMedidasInseridas);
      setResultadoCaixa(resCaixa);
      setGradeRomaneio(resQtdeRomaneio);
      setAtelierDesenhoTecnico(resAtelierDesenhoTecnico);
      setLocalizacaoPilotoAnalise(resLocalizacaoPiloto);
      setPossuiPecaPiloto(resCaixa.possui_peca_piloto);

      const formulariosMedida = [];
      for (const grade of resQtdeRomaneio) {
        const medidas = resMedidas.map(medida => {
          const medidaAtelier = resMedidasAtelier.find(
            m => m.medida.toLowerCase() === medida.label.toLowerCase()
          );

          const medidaFt = medidaAtelier ? medidaAtelier[grade.tamanho] : '0.00';
          const tolerancia = medidaAtelier ? medidaAtelier.tolerancia : '0.000';
          const indice = medidaAtelier ? medidaAtelier.indice : null;
          // Filtra medidas de desenvolvimento interno que não estejam presentes no atelier para esse produto;
          if (medida.id_grupo === 5 && (!medidaAtelier || !medidaAtelier.indice)) return;

          return {
            // switch: resMedidasAtelier.length > 0 && medida.id_grupo === 5 ? true : false,
            // cannot_switch: resMedidasAtelier.length > 0 && medida.id_grupo === 5 ? true : false,
            switch: false,
            indice,
            cannot_switch: false,
            medicao_ft: medidaFt,
            piloto: '',
            amostra_obrigatoria: '',
            amostra_opcional: '',
            medida_aceitavel: false,
            tolerancia,
            medida: medida.value,
            descricao_medida: medida.label,
            id_grupo: medida.id_grupo,
            id_grade: grade.value
          }
        });
        formulariosMedida.push(...medidas);
      }

      const formularios = formulariosMedida.filter(item => item !== undefined).sort((a, b) => {
        if (a.indice !== null && b.indice !== null) return a.indice - b.indice;
        if (a.indice !== null) return -1;
        if (b.indice !== null) return 1;
        return 0;
      });
      setFormulariosMedida([...formularios]);
      setFormulariosPecasComposicaoUm(JSON.parse(JSON.stringify(formularios)));
      setFormulariosPecasComposicaoDois(JSON.parse(JSON.stringify(formularios)));
      setFormulariosPecasComposicaoTres(JSON.parse(JSON.stringify(formularios)));

      // const idOperacao = uuidv4();
      // setIdOperacaoAtiva(idOperacao);

      // socketRef?.current.emit('checklist:iniciar', { idOperacao, arrId: [ref.id_controle], type: 102 }, (res) => {
      //   if (!res.status) toast.error('Erro ao iniciar operação.');
      // });

      // setShowLoadingAnalise(true);

      setReferenciaSelecionada({
        ...ref,
        desenvolvimento_interno: resMedidasAtelier.length > 0
      });
      setModalAnalise(true);
    } catch (e) {
      const errorCode = e?.response?.data?.errorCode;
      if (errorCode === 50001)
        return toast.warn('Não foi possível iniciar o processo. Outro usuário já está analisando a produção');
      if (errorCode === 50002)
        return toast.error('Não foi possível encontrar a grade da referência selecionada.\nPor favor tente novamente ou entre em contato com o suporte.');
      toast.error('Ocorreu um erro inesperado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
      try {
        carregarInformacoesSecundarias(ref);
      } catch (e) {
        // console.error(e);
      }
    }
  }

  const checarSePossuiDefeitos = (index_grade) => {
    const possuiDefeitos = direcionamentoChecklist.some(obj => {
      return obj.grade.index_grade === index_grade;
    });
    return possuiDefeitos;
  }

  const calcularImagensNecessarias = () => {
    const combinacoesSet = new Set();
    direcionamentoChecklist.forEach(item => {
      const { defeitos, localizacao_defeito } = item;
      if (defeitos && localizacao_defeito) {
        const maxLength = Math.min(defeitos.length, localizacao_defeito.length);
        for (let i = 0; i < maxLength; i++) {
          const combination = JSON.stringify({
            defeito: defeitos[i].label,
            localizacao: localizacao_defeito[i].label
          });
          combinacoesSet.add(combination);
        }
      }
    });

    if (precoTagDivergente.key) {
      combinacoesSet.add(JSON.stringify({
        defeito: '115 - ETIQUETA CÓDIGO DE BARRAS COM O PREÇO INCORRETO',
        localizacao: '022 - NAO SE APLICA'
      }));
    }

    if (composicaoTagDivergente.key && composicaoTagDivergente.defeitos.length > 0) {
      combinacoesSet.add(JSON.stringify({
        defeito: composicaoTagDivergente?.defeitos[0]?.label,
        localizacao: '022 - NAO SE APLICA'
      }));
    }

    if (direcionamentoChecklist.some(item => item.defeitos.some(def => def.label.includes('PILOTO')))) {
      combinacoesSet.add(JSON.stringify({
        defeito: 'FOTO DA PILOTO',
        localizacao: '022 - NAO SE APLICA'
      }));
    }

    const direcionamentoPossuiDevolucaoOuDesconto = [20, 21, 26, 43].some(n => {
      return direcionamentoChecklist.some(obj => obj.direcionamento.value === n);
    });

    if (direcionamentoPossuiDevolucaoOuDesconto) {
      combinacoesSet.add(JSON.stringify({
        defeito: 'FOTO DO CABIDE',
        localizacao: 'PEÇA INTEIRA'
      }));
    }

    if (formularioAnalise.gradacao) {
      combinacoesSet.add(JSON.stringify({
        defeito: 'FOTO DA GRADAÇÃO',
        localizacao: 'PEÇAS INTEIRAS'
      }));
    }

    const combinacoesAtualizadas = [];

    combinacoesImagens.forEach(entry => {
      if (combinacoesSet.has(entry.combination)) {
        combinacoesAtualizadas.push(entry);
        combinacoesSet.delete(entry.combination);
      }
    });

    combinacoesSet.forEach(combination => {
      combinacoesAtualizadas.push({ combination, imagem: null });
    });

    setCombinacoesImagens([...combinacoesAtualizadas]);
  }

  useEffect(() => {
    calcularImagensNecessarias();
  }, [direcionamentoChecklist, precoTagDivergente, composicaoTagDivergente, formularioAnalise]);

  const validarProcessamentoAnalise = () => {
    const errArr = [];
    const errObj = {
      peca_piloto: { key: false, label: 'Uma ou mais medidas de peças piloto não foram preenchidas.' },
      amostra_obrigatoria: { key: false, label: 'Uma ou mais amostras obrigatórias não foram preenchidas.' },
      numero_medidas: { key: false, label: 'Você deve inserir ao menos uma medida.' },
      ziper: { key: false, label: 'Preencha a informação sobre o zíper.' },
      gradacao: { key: false, label: 'Preencha a informação sobre a gradação.' },
      fio_detectado: { key: false, label: 'Preencha a informação sobre fio detectado.' },
      defeitos: { key: false, label: 'Insira defeitos para o(s) tamanho(s) sem confirmação.' },
      imagem: { key: false, label: 'Insira todas as imagens exigidas.' },
      preco_tag: { key: false, label: 'Preencha o preço da tag divergente.' },
      composicao_tag: { key: false, label: 'Preencha o defeito da composição divergente.' }
    }

    const formularios = [
      formulariosMedida,
    ];

    if (qtdePecasComposicao > 0) formularios.push(formulariosPecasComposicaoUm);
    if (qtdePecasComposicao > 1) formularios.push(formulariosPecasComposicaoDois);
    if (qtdePecasComposicao > 2) formularios.push(formulariosPecasComposicaoTres);

    let nMedidas = 0;

    formularios.forEach(formulario => {
      formulario.forEach(obj => {
        if (!obj.switch) return;

        if (possuiPecaPiloto && isNullish(obj.piloto)) errObj.peca_piloto.key = true;
        if (isNullish(obj.amostra_obrigatoria)) errObj.amostra_obrigatoria.key = true;

        nMedidas++;
      });
    });

    if (!formularioAnalise.dispensar_medidas && nMedidas === 0) {
      errObj.numero_medidas.key = true;
    }

    if (formularioAnalise.ziper === null) errObj.ziper.key = true;
    if (formularioAnalise.gradacao === null) errObj.gradacao.key = true;
    if (formularioAnalise.fio_detectado === null) errObj.fio_detectado.key = true;

    for (let i = 0; i < gradeRomaneio.length; i++) {
      const item = gradeRomaneio[i];
      if (!item.sem_defeitos && !checarSePossuiDefeitos(item.index_grade)) errObj.defeitos.key = true;
    }
    for (const item of combinacoesImagens) if (!item.imagem) errObj.imagem.key = true;
    for (const item of imagensExtras) if (!item.imagem) errObj.imagem.key = true;

    const precosIguais = parseFloat(precoTagDivergente.value) === parseFloat(referenciaSelecionada.preco_produto) ? true : false;
    if (precoTagDivergente.key && (isNullish(precoTagDivergente.value) || precosIguais)) errObj.preco_tag.key = true;
    if (composicaoTagDivergente.key && composicaoTagDivergente.defeitos.length === 0) errObj.composicao_tag.key = true;

    for (const key in errObj) {
      if (errObj[key].key) errArr.push(errObj[key].label);
    }
    return errArr;
  }

  const abrirModalProcessamento = () => {
    const errArr = validarProcessamentoAnalise();
    if (errArr.length > 0) {
      return toast.warning(() => {
        return <div>{errArr.map((x, i) => <div key={`err_toast_${i}`}>{x}</div>)}</div>
      });
    }
    setModalProcessamento(true);
  }

  const processarChecklistAnalise = async () => {
    try {
      setShowLoading(true);
      const errArr = validarProcessamentoAnalise();
      if (errArr.length > 0) {
        return toast.warning(() => {
          return <div>{errArr.map((x, i) => <div key={`err_toast_${i}`}>{x}</div>)}</div>
        });
      }

      const params = {
        gradeRomaneio,
        direcionamentoChecklist,
        formularioAnalise,
        formulariosMedida: formulariosMedida.filter(item => item.switch),
        formulariosPecasComposicaoUm: qtdePecasComposicao > 0 ? formulariosPecasComposicaoUm.filter(item => item.switch) : [],
        formulariosPecasComposicaoDois: qtdePecasComposicao > 1 ? formulariosPecasComposicaoDois.filter(item => item.switch) : [],
        formulariosPecasComposicaoTres: qtdePecasComposicao > 2 ? formulariosPecasComposicaoTres.filter(item => item.switch) : [],
        id_usuario: userId,
        id_tipo_analise: referenciaSelecionada.nf_segunda_qualidade ? 2 : 1,
        qtde_pecas_amostra: referenciaSelecionada.qtde_pecas_amostra,
        preco_tag_divergente: precoTagDivergente.key ? precoTagDivergente.value : null,
        composicao_tag_divergente: composicaoTagDivergente.key ? composicaoTagDivergente.defeitos[0].value : null,
        possui_peca_piloto: possuiPecaPiloto,
        id_entrada_fiscal: referenciaSelecionada.id_entrada_fiscal
      }

      const formData = new FormData();
      formData.append('params', JSON.stringify(params));

      const arrImagens = [...combinacoesImagens, ...imagensExtras];
      for (const [index, item] of arrImagens.entries()) {
        let nomeArquivo = `imagem_${index}`;
        if (item.combination.includes('FOTO DA GRADAÇÃO')) nomeArquivo = `imagem_${index}_gradacao`;

        try {
          const compressedImage = await imageCompression(item.imagem, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1500,
            useWebWorker: true
          });
          formData.append(nomeArquivo, compressedImage);
        } catch (e) {
          throw 50024;
        }
      }

      await api.post('/pa-checklist/checklist-processamento-analise', formData);

      // await socketRef?.current.emit('checklist:refresh', 1002);
      await fetchChecklistGrid(1002);

      toast.success('Processamento completado com sucesso!');
      resetData();
    } catch (e) {
      if (e === 50024) return toast.error('Erro durante a compressão das imagens. Por favor, tente novamente.');
      if (parseInt(e.message) === 50011) return toast.warning('A referencia selecionada já teve sua revisão lançada.\nSe isso é um erro, por favor entre em contato com a gestão.');
      toast.error('Houve um problema durante o processamento.\nPor favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const toggleSemDefeitos = (index_grade) => {
    gradeRomaneio[index_grade].sem_defeitos = !gradeRomaneio[index_grade].sem_defeitos;
    setGradeRomaneio([...gradeRomaneio]);
  }

  const handleRemoverDirecionamento = (row, index) => {
    const { quantidade, grade } = row;
    try {
      gradeRomaneio[grade.index].quantidade_aprovada += parseInt(quantidade);
      gradeRomaneio[grade.index].quantidade_defeituosa -= parseInt(quantidade);
      direcionamentoChecklist.splice(index, 1);

      setGradeRomaneio([...gradeRomaneio]);
      setDirecionamentoChecklist([...direcionamentoChecklist]);
    } catch (e) {
      toast.error('Encontramos um erro ao remover o direcionamento.\nPor favor tente novamente ou entre em contato com o suporte.');
    }
  }

  const adicionarImagens = (e, index) => {
    const files = Array.from(e.target.files);

    direcionamentoChecklist[index] = {
      ...direcionamentoChecklist[index],
      imagens: [...direcionamentoChecklist[index].imagens, ...files]
    }
    if (direcionamentoChecklist[index].imagens.length > 5) {
      direcionamentoChecklist[index].imagens = direcionamentoChecklist[index].imagens.splice(0, 5);
      toast.warning('Só é possível adicionar cinco imagens por direcionamento');
    }

    setDirecionamentoChecklist([...direcionamentoChecklist]);
  }

  const removerImagem = (indexDir, indexImg) => {
    direcionamentoChecklist[indexDir].imagens.splice(indexImg, 1);
    setDirecionamentoChecklist([...direcionamentoChecklist]);
  }

  // --- Funções Prova de Roupa --- //
  const iniciarChecklistProvaDeRoupa = async (ref) => {
    try {
      setShowLoading(true);

      const params = {
        nf_entrada: ref.nf_entrada,
        serie_nf: ref.serie_nf,
        origem: ref.origem,
        ordem_producao: ref.ordem_producao,
        produto: ref.produto,
        cor_produto: ref.cor_produto,
        qtde_entrada: ref.qtde_entrada,
        filial_revisao: ref.filial_revisao,
        id_controle: ref.id_controle,
        id_entrada_fiscal: ref.id_entrada_fiscal,
        marca: ref.marca,
        romaneio_entrada: ref.romaneio_entrada,
        user_type: interfaceAtiva
      }

      const res = await api.get('/pa-checklist/checklist-iniciar-prova-de-roupa', { params });
      const {
        resGrade,
        resRevisaoResultado,
        resRevisaoDirecionamentos,
        resTipoCorte,
        resMedidasAnalise,
        resImagemDesenhoTecnico,
        exigirImagemCorpoInteiro
      } = res.data;

      setGradeChecklist(resGrade);
      setRevisaoResultado(resRevisaoResultado);
      setRevisaoDirecionamentos(resRevisaoDirecionamentos);
      setMedidasAnalise(resMedidasAnalise);
      setImagemDesenhoTecnico(resImagemDesenhoTecnico);

      // const idOperacao = uuidv4();
      // setIdOperacaoAtiva(idOperacao);

      // socketRef?.current.emit('checklist:iniciar', { idOperacao, arrId: [ref.id_controle], type: 103 }, (res) => {
      //   if (!res.status) toast.error('Erro ao iniciar operação.');
      // });

      // setShowLoadingProvaDeRoupa(true);

      setReferenciaSelecionada({ ...ref, ...resTipoCorte, exigirImagemCorpoInteiro });
      setModalProvaDeRoupa(true);
    } catch (e) {
      const errorCode = e?.response?.data?.errorCode;
      if (errorCode === 50001) return toast.warn('Não foi possível iniciar o processo. Outro usuário já está analisando a produção');
      if (errorCode === 50002) return toast.error('Não foi possível encontrar a grade da referência selecionada.\nPor favor tente novamente ou entre em contato com o suporte.');
      toast.error('Ocorreu um erro inesperado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
      try {
        carregarInformacoesSecundarias(ref);
      } catch (e) {
        // console.error(e);
      }
    }
  }

  const validarProcessamentoProvaDeRoupa = (data) => {
    const { statusAprovacao, imagensProvaDeRoupa, imagensExtrasPdR, defeitosInseridos } = data;

    const errs = [];
    if (!statusAprovacao) errs.push('Status da prova de roupa inválido');
    if (statusAprovacao?.value !== 4 && referenciaSelecionada.exigirImagemCorpoInteiro) {
      const indexImagemCorpo = imagensProvaDeRoupa.findIndex(item => item.localizacao === 'CORPO INTEIRO (FRENTE)');
      if (!imagensProvaDeRoupa[indexImagemCorpo].imagem) errs.push('Insira a imagem de corpo todo');
    }

    for (const item of imagensExtrasPdR) if (!item.imagem) errs.push('Imagens extras inválidas');

    if (statusAprovacao?.value !== 4 && defeitosInseridos.length === 0) errs.push('Insira pelo menos um defeito');
    if (statusAprovacao?.value !== 4) {
      for (const item of imagensProvaDeRoupa) {
        if (!item.imagem) { errs.push('Uma ou mais imagens de defeitos não foram inseridas'); break; }
      }
    }
    return errs;
  }

  const processarProvaDeRoupa = async (data) => {
    const { statusAprovacao, imagensProvaDeRoupa, imagensExtrasPdR, defeitosInseridos, consideracoes } = data;
    try {
      setShowLoading(true);

      const errs = validarProcessamentoProvaDeRoupa(data);
      if (errs.length > 0) return toast.warning(
        <div>
          {errs.map((err, i) => <div key={`err_${i}`}>{err}</div>)}
        </div>
      )

      const params = {
        statusAprovacao,
        defeitosInseridos,
        consideracoes,
        id_usuario_responsavel: userId,
        id_entrada_fiscal: referenciaSelecionada.id_entrada_fiscal,
      }

      const formData = new FormData();
      formData.append('params', JSON.stringify(params));

      const arrImagens = [...imagensProvaDeRoupa, ...imagensExtrasPdR];

      for (const [index, item] of arrImagens.entries()) {
        try {
          const compressedImage = await imageCompression(item.imagem, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1500,
            useWebWorker: true
          });
          formData.append(`imagem_${index}`, compressedImage);
        } catch (e) {
          throw 50024;
        }
      }

      await api.post('/pa-checklist/checklist-processamento-prova-de-roupa', formData);
      // await socketRef?.current.emit('checklist:refresh', 103);
      await fetchChecklistGrid(103);

      toast.success('Processamento completado com sucesso!');
      resetData();
    } catch (e) {
      if (e === 50024) return toast.error('Erro durante a compressão das imagens. Por favor, tente novamente.');
      toast.error('Houve um problema durante o processamento.\nPor favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  // --- Funções Modal Informações  --- //
  useEffect(() => {
    if (ativarModalInformacao) setShowModalInformacoes(true);
  }, [ativarModalInformacao]);

  const abrirModalInformacoes = async (params) => {
    const idEntradaFiscal = params.id_entrada_fiscal;
    if (informacoesCarregadas[idEntradaFiscal]) {
      setInformacaoAtiva(idEntradaFiscal);
      setAtivarModalInformacao(true);
      return;
    }
    carregarInformacoesSecundarias(params);
    setAtivarModalInformacao(true);
  }

  const fecharModalInformacoes = () => {
    setInformacaoAtiva(null);
    setAtivarModalInformacao(false);
    setShowModalInformacoes(false);
  }

  const fetchDefeitos = async (params) => {
    const idEntradaFiscal = params.id_entrada_fiscal;
    try {
      setCarregandoDefeitosPit(true);
      informacoesCarregadas[idEntradaFiscal].defeitosPit = [];
      const resDefeitosPit = await api.get('/pa-revisao/revisao-defeitos-pit', { params });

      informacoesCarregadas[idEntradaFiscal].defeitosPit = resDefeitosPit.data;
      setInformacoesCarregadas({ ...informacoesCarregadas });
    } catch (e) {
      toast.error('Ocorreu um erro ao tentar carregar a lista de defeitos declarados da referência.');
    } finally {
      setCarregandoDefeitosPit(false);
    }
  }

  const fetchChamados = async (params) => {
    const idEntradaFiscal = params.id_entrada_fiscal;
    try {
      setCarregandoChamados(true);
      informacoesCarregadas[idEntradaFiscal].chamados = [];
      const resChamados = await api.get('/pa-revisao/revisao-chamados', { params });
      informacoesCarregadas[idEntradaFiscal].chamados = resChamados.data;
      setInformacoesCarregadas({ ...informacoesCarregadas });
    } catch (e) {
      toast.error('Ocorreu um erro ao tentar carregar a lista de chamados da referência.');
    } finally {
      setCarregandoChamados(false);
    }
  }

  const carregarInformacoesSecundarias = (params) => {
    const idEntradaFiscal = params.id_entrada_fiscal;
    informacoesCarregadas[idEntradaFiscal] = { ...params }
    fetchChamados(params);
    fetchDefeitos(params);

    setInformacaoAtiva(idEntradaFiscal);
  }

  return (
    <PAChecklistContext.Provider
      value={{
        filterObjCaixa, setFilterObjCaixa, filterObjAnalise, setFilterObjAnalise,
        filterObjProvaDeRoupa, setFilterObjProvaDeRoupa,

        listaChecklistAnalise, listaChecklistAnaliseFiltrada, listaDefeitos, listaDefeitosPiloto, listaDestinoInternacional, listaDestinoNacional, listaStatusAnalise, listaStatusDefeito, listaLocalizacaoDefeito, listaMarca, listaCanal, listaDesenvolvimento, listaMedidas, listaDefeitosComp, listaPartesMedidas, listaDefeitosProvaRoupa, listaLocalizacoesProvaRoupa, listaRomaneioMedidas,

        showModalInformacoes, showLoadingCaixa, showLoadingAnalise, showLoadingProvaDeRoupa,
        modalCaixa, subModalCaixa, modalMedidas, modalAnalise, modalDirecionamento, modalProcessamento, modalCancelamento,
        referenciaSelecionada, gradeChecklist, gradeRomaneio, direcionamentoChecklist, quantidadeTotalDirecionada, interfaceAtiva, revisaoResultado, revisaoDirecionamentos, medidasInseridas, medidasAtelier, informacaoAtiva, carregandoDefeitosPit, carregandoChamados, informacoesCarregadas, resultadoCaixa, formularioAnalise, listaMotivoEnvio, listaAreaAprovacao, listaDefeitosComp, listaChecklistCaixa, listaChecklistCaixaFiltrada, limparItemsSelecionadosCaixa, itemEmAnaliseCaixa, formularioCaixa, romaneioSelecionado, combinacoesImagens, precoTagDivergente, composicaoTagDivergente, formulariosMedida,
        listaChecklistProvaDeRoupa, listaChecklistProvaDeRoupaFiltrada, setListaChecklistProvaDeRoupaFiltrada, modalProvaDeRoupa, setModalProvaDeRoupa,

        imagensExtras, setImagensExtras,

        setSubModalCaixa, setModalDirecionamento, setModalMedidas, setModalProcessamento, setModalCancelamento,
        setGradeChecklist, setGradeRomaneio, setDirecionamentoChecklist, setListaChecklistAnaliseFiltrada,
        setInterfaceAtiva, setFormularioAnalise, setListaChecklistCaixaFiltrada, setItemEmAnaliseCaixa,
        setFormularioCaixa, setRomaneioSelecionado, setIdsCancelamento, setCombinacoesImagens,
        setPrecoTagDivergente, setComposicaoTagDivergente, setShowModalInformacoes,

        abrirModalProcessamento, abrirModalInformacoes,
        iniciarChecklistCaixa, iniciarChecklistAnalise, iniciarChecklistProvaDeRoupa,
        fetchChecklistGrid, fetchDefeitos, fetchChamados,
        processarChecklistCaixa, processarChecklistAnalise,
        fecharModalInformacoes, fecharModalCaixa,
        handleRemoverDirecionamento, removerImagem,
        setFormulariosMedida,

        processarProvaDeRoupa, validarProcessamentoProvaDeRoupa,

        toggleSemDefeitos, checarSePossuiDefeitos, adicionarImagens, cancelarChecklist,

        atelierDesenhoTecnico,
        localizacaoPilotoAnalise,
        possuiPecaPiloto, setPossuiPecaPiloto,
        listaProducoesRomaneioSelecionado,
        medidasAnalise, imagemDesenhoTecnico,

        qtdePecasComposicao, setQtdePecasComposicao,
        formulariosPecasComposicaoUm, setFormulariosPecasComposicaoUm,
        formulariosPecasComposicaoDois, setFormulariosPecasComposicaoDois,
        formulariosPecasComposicaoTres, setFormulariosPecasComposicaoTres
      }}
    >
      {< PAChecklistMain />}
    </PAChecklistContext.Provider >
  );
}
